import { useSyncExternalStore } from 'react'
import {
  getSessionIdleRemainingSnapshot,
  subscribeSessionIdleRemaining,
} from './sessionIdleRemainingStore'

export interface SessionIdleCountdownValue {
  /** Milliseconds until idle (or prompt); null when session idle policy is off or not logged in. */
  remainingMs: number | null
}

/**
 * Subscribes to the idle countdown without re-rendering when unrelated parents update.
 * Only components that call this hook re-render when remaining time changes (typically TopBar).
 */
export function useSessionIdleCountdown(): SessionIdleCountdownValue {
  const remainingMs = useSyncExternalStore(
    subscribeSessionIdleRemaining,
    getSessionIdleRemainingSnapshot,
    getSessionIdleRemainingSnapshot
  )
  return { remainingMs }
}

/** Display string for remaining session time (e.g. `12:03` or `1:05:02`). */
export function formatSessionTimeRemaining(ms: number): string {
  const totalSec = Math.max(0, Math.floor(ms / 1000))
  const h = Math.floor(totalSec / 3600)
  const m = Math.floor((totalSec % 3600) / 60)
  const s = totalSec % 60
  if (h > 0) {
    return `${h}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`
  }
  return `${m}:${s.toString().padStart(2, '0')}`
}
